import { Row, Col, Card, Button, Badge, ProgressBar, Modal, Accordion } from 'react-bootstrap';
import {
  Calendar,
  Users,
  Download,
  BookOpen,
  GraduationCap,
  Clock,
  User,
  CalendarDays,
  Check,
  Clock as ClockIcon,
  MapPin,
  Timer,
  FileText,
} from 'lucide-react';
import { toast } from '../common/Toast/toast';
import { styles } from './style';
/* `detail` is GET /attendances/report/batch/:id -- the batch, its summary,
   and its sessions grouped by day, newest first, with every count and
   percentage already worked out by the API over all of the batch's
   sessions in the report's date range. This used to group and count the
   raw records itself, from a list capped at the newest 100 sessions. */
const BatchDetailsModal = ({ show, onHide, detail }) => {
  if (!detail?.batch) return null;

  const batchData = detail.batch;
  const trainer = { trainerName: batchData.trainerName };
  const {
    overallAttendance,
    totalLectures,
    totalPresent: totalPresentAttendances,
    totalPossible: totalPossibleAttendances,
  } = detail.summary;
  const sortedDates = detail.days || [];

  const getAttendanceColor = (percentage) => {
    if (percentage >= 75) return '#10b981';
    if (percentage >= 50) return '#f59e0b';
    return '#ef4444';
  };
  const formatDateTime = (isoString) => {
    if (!isoString) return 'N/A';
    const date = new Date(isoString);

    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'Asia/Kolkata',
    });

    const formattedTime = date.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      timeZone: 'Asia/Kolkata',
    });

    return `${formattedDate}, ${formattedTime}`;
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      backdrop="static"
      className="batch-details-modal"
    >
      <Modal.Header closeButton style={styles.modalHeader} closeVariant="white">
        <Modal.Title className="d-flex align-items-center gap-3">
          <div
            style={{
              background: 'linear-gradient(135deg, rgb(253,126,20), rgb(255,107,69))',
              padding: '0.75rem',
              borderRadius: '12px',
              backdropFilter: 'blur(10px)',
            }}
          >
            <BookOpen size={28} strokeWidth={2} />
          </div>
          <div>
            <h4 className="mb-0 fw-bold" style={{ fontSize: '1.4rem' }}>
              {batchData.batchName || batchData.name}
            </h4>
            <span style={{ fontSize: '0.85rem' }}>Attendance Details & Analytics</span>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={styles.modalBody}>
        <div className="p-4">
          {/* Batch Summary */}
          <Row className="g-4 mb-4">
            <Col lg={6}>
              <Card style={styles.summaryCard}>
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-4">
                    <div
                      style={{
                        ...styles.infoIcon,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      }}
                    >
                      <BookOpen size={18} color="#fff" />
                    </div>
                    <h6 className="mb-0 fw-bold text-dark">Batch Information</h6>
                  </div>

                  <div className="row g-2">
                    <div className="col-6">
                      <div style={styles.infoItem}>
                        <div style={{ ...styles.infoIcon, background: '#dbeafe' }}>
                          <GraduationCap size={16} color="#3b82f6" />
                        </div>
                        <div>
                          <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                            Course
                          </small>
                          <strong style={{ fontSize: '0.9rem' }}>
                            {batchData.courseName || 'N/A'}
                          </strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div style={styles.infoItem}>
                        <div style={{ ...styles.infoIcon, background: '#fce7f3' }}>
                          <User size={16} color="#ec4899" />
                        </div>
                        <div>
                          <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                            Trainer
                          </small>
                          <strong style={{ fontSize: '0.9rem' }}>
                            {trainer.trainerName || 'N/A'}
                          </strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div style={styles.infoItem}>
                        <div style={{ ...styles.infoIcon, background: '#d1fae5' }}>
                          <Users size={16} color="#10b981" />
                        </div>
                        <div>
                          <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                            Total Students
                          </small>
                          <strong style={{ fontSize: '0.9rem' }}>
                            {batchData.totalStudents || 0}
                          </strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div style={styles.infoItem}>
                        <div style={{ ...styles.infoIcon, background: '#fef3c7' }}>
                          <MapPin size={16} color="#f59e0b" />
                        </div>
                        <div>
                          <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                            Mode
                          </small>
                          <strong style={{ fontSize: '0.9rem' }}>{batchData.mode || 'N/A'}</strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div style={styles.infoItem}>
                        <div style={{ ...styles.infoIcon, background: '#e0e7ff' }}>
                          <Timer size={16} color="#6366f1" />
                        </div>
                        <div>
                          <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>
                            Timing
                          </small>
                          <strong style={{ fontSize: '0.9rem' }}>
                            {' '}
                            {formatDateTime(batchData.startTime)}
                            {' - '}
                            {formatDateTime(batchData.endTime)}
                          </strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div style={styles.infoItem}>
                        <div style={{ ...styles.infoIcon, background: '#fae8ff' }}>
                          <Calendar size={16} color="#a855f7" />
                        </div>
                        <div className="d-flex flex-column gap-1">
                          <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                            Days
                          </small>
                          <strong className="text-break" style={{ fontSize: '0.9rem' }}>
                            {batchData.days || 'N/A'}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6}>
              <Card style={styles.summaryCard}>
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-4">
                    <div
                      style={{
                        ...styles.infoIcon,
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                      }}
                    >
                      <Check size={18} color="#fff" />
                    </div>
                    <h6 className="mb-0 fw-bold text-dark">Attendance Summary</h6>
                  </div>

                  <Row className="g-3">
                    <Col xs={6}>
                      <div style={styles.statBox}>
                        <div
                          style={{
                            ...styles.statValue,
                            color: getAttendanceColor(overallAttendance),
                          }}
                        >
                          {overallAttendance}%
                        </div>
                        <div style={styles.statLabel}>Overall Attendance</div>
                        <ProgressBar
                          now={overallAttendance}
                          style={{
                            height: '6px',
                            marginTop: '0.75rem',
                            backgroundColor: 'rgba(102, 126, 234, 0.1)',
                            borderRadius: '3px',
                          }}
                          variant={
                            overallAttendance >= 75
                              ? 'success'
                              : overallAttendance >= 50
                                ? 'warning'
                                : 'danger'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div style={styles.statBox}>
                        <div style={{ ...styles.statValue, color: '#3b82f6' }}>{totalLectures}</div>
                        <div style={styles.statLabel}>Total Lectures</div>
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div style={styles.statBox}>
                        <div style={{ ...styles.statValue, color: '#10b981' }}>
                          {totalPresentAttendances}
                        </div>
                        <div style={styles.statLabel}>Total Present</div>
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div style={styles.statBox}>
                        <div style={{ ...styles.statValue, color: '#f59e0b' }}>
                          {totalPossibleAttendances}
                        </div>
                        <div style={styles.statLabel}>Total Possible</div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Attendance by Date */}
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="d-flex align-items-center gap-3">
              <div
                style={{
                  ...styles.infoIcon,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  width: '42px',
                  height: '42px',
                }}
              >
                <CalendarDays size={20} color="#fff" />
              </div>
              <div>
                <h5 className="mb-0 fw-bold">Attendance Records</h5>
                <small className="text-muted">Detailed view by date</small>
              </div>
            </div>
            <Badge
              pill
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '0.5rem 1rem',
                fontSize: '0.85rem',
              }}
            >
              {sortedDates.length} Days
            </Badge>
          </div>

          {sortedDates.length > 0 ? (
            <Accordion
              defaultActiveKey="0"
              className="shadow-sm"
              style={{ borderRadius: '16px', overflow: 'hidden' }}
            >
              {sortedDates.map((day, index) => {
                const dayPercentage = day.attendancePercentage;

                return (
                  <Accordion.Item
                    key={day.dateStr}
                    eventKey={index.toString()}
                    style={{ border: 'none', borderBottom: '1px solid rgba(102, 126, 234, 0.1)' }}
                  >
                    <Accordion.Header style={styles.accordionHeader}>
                      <div className="d-flex justify-content-between align-items-center w-100 pe-3">
                        <div className="d-flex align-items-center gap-3">
                          <span style={styles.dateHeaderBadge}>
                            <Calendar size={16} />
                            {day.dateStr}
                          </span>
                          <Badge
                            bg="light"
                            text="dark"
                            style={{
                              padding: '0.4rem 0.8rem',
                              borderRadius: '8px',
                              fontWeight: '500',
                            }}
                          >
                            {day.records.length} Lecture{day.records.length !== 1 ? 's' : ''}
                          </Badge>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                          <div
                            style={{
                              ...styles.studentBadge,
                              ...styles.presentBadge,
                              padding: '0.4rem 1rem',
                            }}
                          >
                            <Check size={14} />
                            <span>{day.totalPresent} Present</span>
                          </div>
                          <span style={styles.percentageBadge}>{dayPercentage}%</span>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body style={{ background: '#fafbff', padding: '1.25rem' }}>
                      {day.records.map((record, recordIndex) => (
                        <Card key={record.id || recordIndex} style={styles.lectureCard}>
                          <Card.Body className="p-3">
                            <Row className="align-items-center">
                              <Col md={8}>
                                <div className="mb-2">
                                  <Badge
                                    style={{
                                      background:
                                        'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                      padding: '0.4rem 0.8rem',
                                      borderRadius: '6px',
                                      fontWeight: '600',
                                      marginBottom: '0.5rem',
                                    }}
                                  >
                                    Lecture {recordIndex + 1}
                                  </Badge>
                                  <h6 className="mb-1 d-flex align-items-center gap-2 mt-2">
                                    <FileText size={16} className="text-primary" />
                                    <span>{record.syllabusId || 'No Topic'}</span>
                                  </h6>
                                  <small className="text-muted d-flex align-items-center gap-1">
                                    <ClockIcon size={12} />
                                    Time:{' '}
                                    {new Date(record.date || record.createdAt).toLocaleTimeString(
                                      'en-IN',
                                      {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                      }
                                    )}
                                  </small>
                                </div>
                              </Col>
                              <Col md={4}>
                                <div className="text-md-end">
                                  <div className="mb-2">
                                    <span
                                      style={{
                                        ...styles.studentBadge,
                                        ...styles.presentBadge,
                                        fontSize: '0.85rem',
                                        padding: '0.5rem 1rem',
                                      }}
                                    >
                                      <User size={14} />
                                      {record.presentCount} / {day.totalStudents} Students
                                    </span>
                                  </div>
                                  <div className="text-muted small d-flex align-items-center gap-1 justify-content-md-end">
                                    <ClockIcon size={12} />
                                    {new Date(record.date).toLocaleTimeString('en-IN')}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          ) : (
            <div style={styles.emptyState}>
              <div
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #667eea20 0%, #764ba220 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1.5rem',
                }}
              >
                <Clock size={36} color="#667eea" />
              </div>
              <h5 className="fw-bold mb-2">No Attendance Records Found</h5>
              <p className="text-muted mb-0">No attendance has been marked for this batch yet.</p>
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer style={styles.modalFooter}>
        <Button
          variant="light"
          onClick={onHide}
          style={{
            padding: '0.6rem 1.5rem',
            borderRadius: '10px',
            fontWeight: '600',
            border: '1px solid rgba(102, 126, 234, 0.2)',
          }}
        >
          Close
        </Button>
        <Button
          style={styles.exportBtn}
          onClick={() => {
            console.log('Export batch data:', batchData);
            toast.info('Export feature would be implemented here');
          }}
        >
          <Download size={18} />
          Export Data
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BatchDetailsModal;
